
import Icon from "@/components/UI/Icon.vue";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {
    Icon
  }
})
export default class TogglePanel extends Vue {
  @Prop({ type: String, default: "" })
  title!: string;

  @Prop({ type: Boolean, default: false })
  isLoading!: boolean;

  @Prop({ type: Boolean, default: false })
  open!: boolean;

  isOpen: boolean = this.open;

  @Watch("isOpen")
  onIsOpenChanged(val: boolean) {
    this.isOpen = val;
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.$emit("update:isOpen", this.isOpen);
  }
}
